export default __webpack_public_path__ + "slices/main/assets/public/media/error-page@2x.d04543e3e187bb004d61fba28b3e98ff.png";